module.exports = __webpack_public_path__ + "static/img/sicherefixierung.178cf777.svg";